import { Component, OnInit } from '@angular/core';
import { CoursewareService } from 'src/services/CoursewareService';
import { MemberUserData } from 'src/model/User/MemberUserData';
import { Error } from 'src/model/Error';
import { AlertService } from '../_alert';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { globals } from '../shared/globals';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  public hasSentPassword: boolean = false;

  constructor(private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) { }

  ngOnInit() {
  }

  public forgotPassword(form: NgForm) {
    this.alertService.clear();
    this.coursewareService.ForgotPassword(form.value.email).subscribe(data => {
      if (data != null && data == "SUCCESS") {
        this.hasSentPassword = true;
      } else {
        let error = data as Error
        this.alertService.error(error.Message);
      }
    },
      error => this.alertService.error("Caught unexpected error when logging in " + error.Message));
  }
}
